/**
 * #724 — whose S opt-in is it?
 *
 * Display settings live in browser storage and are shared by every trader who
 * signs in on that browser. A plain boolean therefore let the next trader on a
 * shared desk inherit a key that fires two orders, and switch it for the
 * previous one. The opt-in now records the trader who turned it on, and counts
 * only for that trader; for anyone else S is off, exactly as if never enabled.
 *
 * A stored `true` with no owner (written before the owner existed) reads as
 * off: the trader opts in again once, deliberately.
 */
export interface TwoSidedOptInState {
  lt2TwoSidedEnabled: boolean;
  lt2TwoSidedOwnerId: string | null;
}

export function twoSidedOptedIn(s: TwoSidedOptInState, viewerId: string | null): boolean {
  return s.lt2TwoSidedEnabled && viewerId != null && s.lt2TwoSidedOwnerId === viewerId;
}
